/**
 * @packageDocumentation
 *
 * This module serves as the entry point for `@libp2p/interface-internal`,
 * exporting key components such as `AddressManager`, `ConnectionManager`,
 * `RandomWalk`, `Registrar`, and `TransportManager`.
 *
 * These interfaces and classes define the core internal behaviors of libp2p.
 */

export * from './address-manager.js'
export * from './connection-manager.js'
export * from './random-walk.js'
export * from './registrar.js'
export * from './transport-manager.js'
